import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { WhereDidYouHearOptionEnum } from 'types/api/enums'

export enum Persona {
  CASUAL_PLAY = 'CASUAL_PLAY', // I play casually with friends and family
  COMPETITIVE_PLAY = 'COMPETITIVE_PLAY', // I play competitively in tournaments and leagues
  INTEREST_ONLY = 'INTEREST_ONLY', // I don't play but I have an interest in tennis
  COACH = 'COACH', // I coach tennis
  PARENT_OR_CARER = 'PARENT_OR_CARER', // I am a parent/carer of a Juniors player
  OTHER = 'OTHER', // Other
}

export const usePersonaOptions = () => {
  const { t } = useTranslation('strRegister')

  return useMemo(
    () =>
      [
        Persona.CASUAL_PLAY,
        Persona.COMPETITIVE_PLAY,
        Persona.INTEREST_ONLY,
        Persona.COACH,
        Persona.PARENT_OR_CARER,
        Persona.OTHER,
      ].map(persona => ({
        label: t(`personas.${persona}`),
        value: persona,
      })),
    [t]
  )
}

export const useWhereDidYouHearOptions = () => {
  const { t } = useTranslation('strRegister')

  return useMemo(
    () =>
      [
        WhereDidYouHearOptionEnum.NA,
        WhereDidYouHearOptionEnum.TENNIS_CLUB,
        WhereDidYouHearOptionEnum.TENNIS_TOURNAMENT,
        WhereDidYouHearOptionEnum.WORD_OF_MOUTH,
        WhereDidYouHearOptionEnum.SOCIAL_MEDIA,
        WhereDidYouHearOptionEnum.SEARCH_ENGINE,
        WhereDidYouHearOptionEnum.BLOG_OR_PUBLICATION,
        WhereDidYouHearOptionEnum.OTHER,
      ].map(option => ({
        label: t(`whereDidYouHear.${option}`),
        value: option,
      })),
    [t]
  )
}

